<template>
  <div>
    <h2 class="title font-weight-regular mb-3">{{ config.heading }}</h2>
    <gg-card>
      <gg-card-text>
        <div class="feature-setup text-center py-8 px-4">
          <div class="feature-setup__icon mx-auto mb-4">
            <v-icon aria-hidden="true">{{ config.icon }}</v-icon>
          </div>
          <h3 class="subtitle-1 font-weight-bold mb-1">{{ config.title }}</h3>
          <p class="body-2 text--secondary mb-5">{{ config.description }}</p>
          <gg-btn primary @click="$emit('create')">{{ config.action }}</gg-btn>
          <div v-if="config.learnMore" class="mt-4">
            <a
              :href="config.learnMore"
              target="_blank"
              rel="noopener"
              class="body-2 font-weight-medium feature-setup__link"
            >
              Learn more
              <v-icon small class="ml-1" aria-hidden="true">mdi-open-in-new</v-icon>
            </a>
          </div>
        </div>
      </gg-card-text>
    </gg-card>
  </div>
</template>

<script>
import { EMAIL_FEATURE_SETUP } from '@/consts/email'

/**
 * The one screen an email feature shows while nothing is set up (AM-1107):
 * icon, a call to create the first item, and the feature's help article.
 * The texts live in EMAIL_FEATURE_SETUP so every feature reads the same way.
 */
export default {
  name: 'FeatureSetup',
  props: {
    // A key of EMAIL_FEATURE_SETUP.
    feature: {
      type: String,
      required: true,
      validator: value => value in EMAIL_FEATURE_SETUP,
    },
  },
  computed: {
    config () {
      return EMAIL_FEATURE_SETUP[this.feature]
    },
  },
}
</script>

<style lang="scss" scoped>
.feature-setup__icon {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 40px;
  height: 40px;
  border-radius: 8px;
  background: rgba(0, 0, 0, 0.06);
}

.theme--dark .feature-setup__icon {
  background: rgba(255, 255, 255, 0.1);
}

.feature-setup__link {
  color: inherit;
  text-decoration: none;

  .v-icon {
    color: inherit;
  }

  &:hover {
    text-decoration: underline;
  }
}
</style>
